import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border relative" data-id="element-103">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-accent/5 via-brand-accent/10 to-brand-accent/5 pointer-events-none" data-id="element-104"></div>
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-105">
        <div className="flex justify-center mb-8" data-id="element-106">
          <div className="bg-brand-accent/10 border border-brand-accent/20 p-5 rounded-full text-5xl" data-id="element-107">
            🛡️
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-8 text-white" data-id="element-108">
          TOTAL GUARANTEE — 7 DAYS
        </h2>
        <div className="text-lg md:text-xl space-y-6 max-w-2xl mx-auto" data-id="element-109">
          <p className="text-white/70 bg-brand-card p-5 rounded-2xl border border-brand-border" data-id="element-110">
            Download everything. Browse the volumes. Try a blueprint on the ice
            tomorrow.
          </p>
          <p className="font-bold text-2xl text-white mt-8" data-id="element-111">
            If for any reason you feel that Ice Hockey Ready doesn't save you
            time:
          </p>
          <div className="py-4" data-id="element-112">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-3xl md:text-4xl font-heading font-black text-brand-dark bg-brand-accent inline-block px-8 py-3 rounded-xl transform -rotate-1 cursor-pointer hover:scale-105 transition-transform" data-id="element-113">
              We refund you 100%.
            </button>
          </div>
          <p className="font-bold text-xl text-white/80" data-id="element-114">
            No questions asked. Send us an email and we refund you down to the
            last cent.
          </p>
          <p className="text-white/70 italic" data-id="element-115">
            The confidence we have in Ice Hockey Ready is what lets us offer you
            this.
          </p>
        </div>
      </div>
    </section>;
}